import { Routes } from '@angular/router';
import { LoginComponent } from './Common/login/login.component';
import { HomeComponent } from './Dashboard/home/home.component';
import { AuthGuard } from './auth.guard';

export const routes: Routes = [
    {path:'', pathMatch:'full', redirectTo:'login'},
    {path:'login', component:LoginComponent},
    // {path:'dashboard', component:HomeComponent, canActivate: [AuthGuard]}
    {path:'dashboard', component:HomeComponent, canActivate: [AuthGuard]}
];
